module.exports = __webpack_public_path__ + "static/fonts/Montserrat-Regular.92db9a0.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Montserrat/Montserrat-Regular.otf
// module id = 1669
// module chunks = 4